module.exports = __webpack_public_path__ + "static/media/Linux.9c89f7ea.svg";